import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText } from "lucide-react";

function chf(n) { return "CHF " + Number(n || 0).toLocaleString("de-CH", { minimumFractionDigits: 2 }); }

export default function EstimatesHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/calculator/history").then(({ data }) => { setItems(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="estimates-history">
      <h2 className="font-heading text-3xl font-bold text-[#1A2433] mb-2">Meine Angebote</h2>
      <p className="text-slate-600 mb-8">Alle in Ihrem Konto gespeicherten Kalkulationen.</p>

      {loading ? <div className="text-slate-500">Lade…</div> : items.length === 0 ? (
        <div className="text-center py-12 bg-slate-50 rounded-xl">
          <FileText className="w-10 h-10 text-slate-400 mx-auto mb-3" />
          <p className="text-slate-600 mb-4">Noch keine gespeicherten Angebote.</p>
          <a href="/rechner" className="btn-primary">Jetzt kalkulieren</a>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((it) => (
            <div key={it.id} className="border border-slate-200 rounded-xl p-6" data-testid={`estimate-row-${it.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <div className="font-heading text-lg font-semibold text-[#1A2433]">{it.result.service_label}</div>
                  <div className="text-xs text-slate-500">{new Date(it.created_at).toLocaleString("de-CH")}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs uppercase tracking-wider text-slate-500">Total</div>
                  <div className="font-heading text-2xl font-bold text-[#991B1B] tabular-nums">{chf(it.result.total_chf)}</div>
                </div>
              </div>
              <div className="text-xs text-slate-500">
                Komplexität: <span className="font-medium text-slate-700">{it.result.complexity}</span> ·
                Add-ons: <span className="font-medium text-slate-700">{(it.result.addons || []).length}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
